import React from 'react';
import { useI18n, type Language } from '../i18n';

const languages: { code: Language; label: string; flag: string }[] = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'pt', label: 'Português', flag: '🇵🇹' }
];

export function LanguageSelector() {
  const { language, setLanguage } = useI18n();

  return (
    <div className="relative group z-50">
      <button 
        type="button"
        className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white/5 hover:bg-white/10 transition-colors border border-white/10"
      >
        <span className="text-lg">{languages.find(l => l.code === language)?.flag}</span>
        <span className="text-sm text-gray-300 hidden sm:inline">
          {languages.find(l => l.code === language)?.label}
        </span>
      </button>

      <div className="absolute right-0 mt-1 py-1 bg-gray-900/95 backdrop-blur-xl rounded-lg border border-white/10 shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
        {languages.map(({ code, label, flag }) => (
          <button
            key={code}
            onClick={() => setLanguage(code)}
            className={`w-full flex items-center gap-3 px-4 py-2 text-sm transition-colors ${
              code === language
                ? 'bg-indigo-500/20 text-indigo-400'
                : 'text-gray-300 hover:bg-white/5'
            }`}
          >
            <span className="text-lg">{flag}</span>
            <span>{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}